import { render, staticRenderFns } from "./vue-cropper.vue?vue&type=template&id=32d2cd64&scoped=true"
import script from "./vue-cropper.vue?vue&type=script&lang=js"
export * from "./vue-cropper.vue?vue&type=script&lang=js"
import style0 from "./vue-cropper.vue?vue&type=style&index=0&id=32d2cd64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2cd64",
  null
  
)

export default component.exports